// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-settings {
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}
.global-settings h1 {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  font-weight: 800;
  background-color: var(--primary-color);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.025em;
}
.global-settings h1::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #1e293b 0%, var(--primary-color) 50%, var(--primary-color) 100%);
  border-radius: 2px;
}
.global-settings .settings-tabs {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  background: white;
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  flex-wrap: wrap;
}
.global-settings .settings-tabs button {
  padding: 0.75rem 1.25rem;
  border: none;
  background: transparent;
  color: #64748b;
  font-weight: 500;
  font-size: 0.95rem;
  border-radius: 0;
  cursor: pointer;
  transition: color 0.2s ease;
  position: relative;
}
.global-settings .settings-tabs button:hover {
  color: #1e293b;
}
.global-settings .settings-tabs button.active {
  color: #1e293b;
  font-weight: 600;
}
.global-settings .settings-tabs button.active::after {
  content: "";
  position: absolute;
  bottom: 6px;
  left: 0;
  right: 0;
  margin: auto;
  width: 50%;
  height: 2px;
  background: var(--primary-color, #667eea);
  border-radius: 1px;
}
.global-settings .settings-section {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}
@media (max-width: 768px) {
  .global-settings {
    padding: 1rem;
  }
  .global-settings h2 {
    font-size: 2rem;
  }
  .global-settings .settings-tabs {
    gap: 0.25rem;
  }
  .global-settings .settings-tabs button {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }
  .global-settings .settings-section {
    padding: 1.5rem;
  }
}
@media (max-width: 480px) {
  .global-settings .settings-tabs {
    flex-direction: column;
  }
  .global-settings .settings-tabs button {
    width: 100%;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/GlobalSettingsPage.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6DAAA;AACF;AACE;EAYE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,wBAAA;AAVJ;AAeI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,oGAAA;EACA,kBAAA;AAbN;AAiBE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,2BAAA;EACA,eAAA;AAfJ;AAiBI;EACE,wBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AAfN;AAiBM;EACE,cAAA;AAfR;AAkBM;EACE,cAAA;EACA,gBAAA;AAhBR;AAkBQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,yCAAA;EACA,kBAAA;AAhBV;AAwBE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;EACA,0CAAA;EAGA,gBAAA;AAxBJ;AA0BE;EAtGF;IAuGI,aAAA;EAvBF;EAyBE;IACE,eAAA;EAvBJ;EA0BE;IACE,YAAA;EAxBJ;EA0BI;IACE,qBAAA;IACA,mBAAA;EAxBN;EA4BE;IACE,eAAA;EA1BJ;AACF;AA6BE;EACE;IACE,sBAAA;EA3BJ;EA6BI;IACE,WAAA;IACA,kBAAA;EA3BN;AACF","sourcesContent":[".global-settings {\n  padding: 2rem;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n\n  h1 {\n    // font-size: 2.5rem;\n    // font-weight: 800;\n    // color: #1e293b;\n    // margin-bottom: 2rem;\n    // text-align: center;\n    // background: linear-gradient(135deg, #1e293b 0%, var(--primary-color) 50%, var(--primary-color) 100%);\n    // -webkit-background-clip: text;\n    // -webkit-text-fill-color: transparent;\n    // background-clip: text;\n    // position: relative;\n    \n    text-align: center;\n    margin-bottom: 2rem;\n    font-size: 2rem;\n    font-weight: 800;\n    background-color: var(--primary-color);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    letter-spacing: -0.025em;\n\n\n\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: -10px;\n      left: 50%;\n      transform: translateX(-50%);\n      width: 80px;\n      height: 4px;\n      background: linear-gradient(135deg, #1e293b 0%, var(--primary-color) 50%, var(--primary-color) 100%);\n      border-radius: 2px;\n    }\n  }\n\n  .settings-tabs {\n    display: flex;\n    justify-content: center;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    background: white;\n    padding: 0.5rem;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n    flex-wrap: wrap;\n\n    button {\n      padding: 0.75rem 1.25rem;\n      border: none;\n      background: transparent;\n      color: #64748b;\n      font-weight: 500;\n      font-size: 0.95rem;\n      border-radius: 0;\n      cursor: pointer;\n      transition: color 0.2s ease;\n      position: relative;\n\n      &:hover {\n        color: #1e293b;\n      }\n\n      &.active {\n        color: #1e293b;\n        font-weight: 600;\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 6px;\n          left: 0;\n          right: 0;\n          margin: auto;\n          width: 50%;\n          height: 2px;\n          background: var(--primary-color, #667eea);\n          border-radius: 1px;\n        }\n      }\n\n    }\n  }\n\n\n  .settings-section {\n    background: white;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    // backdrop-filter: blur(20px);\n    // position: relative;\n    overflow: hidden;\n  }\n  @media (max-width: 768px) {\n    padding: 1rem;\n\n    h2 {\n      font-size: 2rem;\n    }\n\n    .settings-tabs {\n      gap: 0.25rem;\n\n      button {\n        padding: 0.75rem 1rem;\n        font-size: 0.875rem;\n      }\n    }\n\n    .settings-section {\n      padding: 1.5rem;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .settings-tabs {\n      flex-direction: column;\n\n      button {\n        width: 100%;\n        text-align: center;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
